<template>
	<label
		class="flex items-center bg-slate-50 border border-blue-300 rounded-md hover:shadow-md focus-within:shadow-sm transition w-full overflow-x-hidden relative">
		<div class="flex items-start w-full">
			<p v-if="$slots.icon" class="mr-3"><slot name="icon"></slot></p>
			<textarea
				class="pb-0.5 pt-4 px-2 text-slate-700 bg-slate-50 border-none focus:ring-0 focus:outline-none w-full flex-grow peer h-24 resize-none sm:text-md text-sm"
				:value="modelValue"
				@input="$emit('update:modelValue', $event.target.value)"
				:disabled="disabled"></textarea>
			<p
				class="absolute text-blue-400 text-base ml-2 mt-2 origin-left transform start-[0] peer-focus:-translate-y-1/2 peer-focus:scale-75 transition sm:text-md text-sm"
				:class="[modelValue ? '-translate-y-1/2 scale-75' : '', $slots.icon ? 'pb-0.5 pt-4 pl-6' : '']">
				{{ placeholder }}
			</p>
		</div>
	</label>
</template>

<script setup>
	defineProps({
		placeholder: {
			type: String,
			default: '',
		},
		modelValue: {
			type: [String, Number],
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	});

	defineEmits(['update:modelValue']);
</script>
